import React from 'react';
import Blogs from './BlogPosts';
import { useQuery } from '@apollo/client';
import GraphQLLoader from '../../../../common/graphql/graphql-loader';
import { BLOG_POSTS_QUERY, BlogPostsQuery } from '../../../../common/graphql/blogs/blogpost-graphql';

const BlogsLoader: React.FC = () => {
  const { loading, error, data } = useQuery<BlogPostsQuery>(BLOG_POSTS_QUERY);
  return (
    <GraphQLLoader loading={loading} error={error}>
      {!loading && !error && <Blogs blogs={data!.blogPosts} blogLinkPrefix="/blog" />}
    </GraphQLLoader>
  );
};

export default BlogsLoader;
